import { render, staticRenderFns } from "./Growth.vue?vue&type=template&id=48e15c76&scoped=true&"
import script from "./Growth.vue?vue&type=script&lang=ts&"
export * from "./Growth.vue?vue&type=script&lang=ts&"
import style0 from "./Growth.vue?vue&type=style&index=0&id=48e15c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e15c76",
  null
  
)

export default component.exports